import { svg } from "../Assets/svg";

export const MaterialUnits = [
  {
    label: "Each",
    value: "Each",
  },
  {
    label: "Cubic Feet",
    value: "Cubic Feet",
  },
  {
    label: "Cubic Yards",
    value: "Cubic Yards",
  },
  {
    label: "Gallons",
    value: "Gallons",
  },
  {
    label: "Linear Feet",
    value: "Linear Feet",
  },
  {
    label: "Linear Yards",
    value: "Linear Yards",
  },
  {
    label: "Pounds",
    value: "Pounds",
  },
  {
    label: "Square Feet",
    value: "Square Feet",
  },
  {
    label: "Square Yards",
    value: "Square Yards",
  },
  {
    label: "Tons",
    value: "Tons",
  },
  {
    label: "Ounces",
    value: "Ounces",
  },
  {
    label: "Liters",
    value: "Liters",
  },
  {
    label: "Quarts",
    value: "Quarts",
  },
  {
    label: "Pints",
    value: "Pints",
  },
];

export const ConsumableUnits = [
  {
    label: "Each",
    value: "Each",
  },
  {
    label: "Cubic Feet",
    value: "Cubic Feet",
  },
  {
    label: "Cubic Yards",
    value: "Cubic Yards",
  },
  {
    label: "Gallons",
    value: "Gallons",
  },
  {
    label: "Linear Feet",
    value: "Linear Feet",
  },
  {
    label: "Linear Yards",
    value: "Linear Yards",
  },
  {
    label: "Pounds",
    value: "Pounds",
  },
  {
    label: "Square Feet",
    value: "Square Feet",
  },
  {
    label: "Square Yards",
    value: "Square Yards",
  },
  {
    label: "Tons",
    value: "Tons",
  },
  {
    label: "Ounces",
    value: "Ounces",
  },
  {
    label: "Liters",
    value: "Liters",
  },
  {
    label: "Quarts",
    value: "Quarts",
  },
  {
    label: "Pints",
    value: "Pints",
  },
];

export const EmployeeSuffix = ["Junior", "Senior"];

export const EmployeeSex = [
  { value: "m", name: "Male" },
  { value: "f", name: "Female" },
  { value: "o", name: "Other" },
];

export const EmployeePosition = [
  { id: "01", name: "Manager" },
  { id: "02", name: "Supervisor" },
  { id: "03", name: "Employee" },
  { id: "04", name: "Intern" },
];

export const EmploymentStatus = [
  { id: "01", name: "Part Time" },
  { id: "02", name: "Full Time" },
  { id: "03", name: "Contract" },
  { id: "04", name: "Fixed Term" },
];

export const GenderValue: any = {
  m: "Male",
  f: "Female",
  o: "Other",
};

export const RelationsArray = ["Father", "Mother", "Brother", "Sister", "Son", "Daughter", "Wife"];

export const CellPhoneCompany = ["Verizon", "AT&T", "T-Mobile", "Sprint", "Boost Mobile", "U.S. Cellular"];

export const MeasurementList = [
  "Feet",
  "Each",
  "Cubic Feet",
  "Square Feet",
  "Meters",
  "Gallons",
  "Yard",
  "Square Yard",
  "Cubic Yard",
  "Pound",
  "Tons",
  "Ounces",
  "Liters",
  "Quarts",
  "Pints",
];

export const LeadMeasurementList = ["Feet", "Meters"];

export const LeadServices = {
  springCommission: "6798bf72466be0da90d2e6c6",
  exteriorPaintwork: "6798bc970f30b77e1d6443c5",
  interiorPaintwork: "6798bc9cf7b6e08cde0ae475",
  varnishInterior: "6798bca156aef77282fdbc45",
  varnishExterior: "6798bca5b2607d14bf4404cb",
  cabinSoles: "6798bcaafad350fb5ea26464",
  awlgripTouchups: "6798bcb08bee18bb910102c4",
  gelcoatFiberglassRepairs: "6798bcb68ca6c131c2ca428e",
  paintBottom: "6798bcbd7e61be53bf8614d1",
  compoundWaxTopsides: "6798bcc30e48d319b86adf04",
  compoundWaxDeck: "6798bccfc40ccdde4697b61b",
  polishStainless: "6798bcd5ec3ec11e3d900911",
  thoroughInteriorClean: "6798bce220939b0b25b44670",
  cushionsClean: "6798b3ebe422cb287733c10b",
  cushionsRepair: "6798b3f1b4e8de1efafbad19",
  cushionsStore: "6798b3f7cf9cc75a60d218ee",
  sailsCanvasClean: "6798b2c795ab06d5787d7d3c",
  sailsCanvasRepair: "6798b2ce55bb4ece748592af",
  sailsCanvasStore: "6798b2d4e766323e7dd8c483",
  winterStoreInsideUpto500sf: "6798743624f441645b352a96",
  winterStoreOutsideUpto500sf: "67987475b50d20dce72d9ef4",
  winterStoreInsideOver500sf: "67f648353ff4241731a212e9",
  winterStoreOutsideOver500sf: "67f6483dd8997c4fedcb3f5a",
  summerStoreInsideUpto500sf: "6846e25509f21ac97f06e7a3",
  summerStoreOutsideUpto500sf: "6846e25de1f36d0d0a2de911",
  summerStoreInsideOver500sf: "6846e2635a2a811766b9c15b",
  summerStoreOutsideOver500sf: "6846e269665f696a2b9c8b1d",
  fallDecommission: "679879f35682e872077ef66f",
  deRingAndUnstepFull: "67987c54f19ad2a90b13e631",
  deRingAndUnstepPartial: "67987d5f47857394503ef1cf",
  serviceWinches: "6798827a0e43055c31ab6534",
  serviceWindlass: "679dde8ec207c6f303470476",
  serviceSeaCocks: "679dde9f1e3832ca2bd5ffa0",
  serviceBatteryMaintenance: "679ddeaace7a32dcad257c4d",
  changeZincs: "679ddeb4ca59b76168dd45da",
  moistureCheck: "679ddebf8b5943c623662249",
  dinghyStore: "67989ceec4e2d2d2a6cc9bef",
  OutboardWinterizeAndStore: "67989d61ec298e8a5863d054",
  mastStorage: "67c5a094e811e38e12441975",
  storageLockersSmall: "67c5adae56b94d18b6676b6a",
  storageLockersLarge: "67c5adbb41b6963f1082ccce",
  trailerService: "6798ae55b51b6508ddadc607",
  shrinkWrap: "6798afc97a62f1206aaa63e7",
  installOwnersCover: "6798afd837f089e61207548c",
  completeRig: "6798c135e400c98fc3787beb",
  partialRig: "6798c13b2aa242cac713d5d7",
  wireMast: "6798c140e2ab186696947939",
  tuneAndTapeRig: "6798c145ece1195d039e3d14",
  putOnBoom: "6798c14a6bbf817125284a4f",
  fuelBoat: "6798c14fc3d3194ac8392241",
  fillWaterTanks: "6798c155eb372889361fc288",
  scrubDecks: "6798c15ce4557d9971607f00",
  deliverBoatTo: "6798c1600808457a3eb9fefd",
};

export const StaticServiceArray = [
  {
    id: LeadServices?.serviceWinches,
    value: "Service Winches",
  },
  {
    id: LeadServices?.serviceWindlass,
    value: "Service Windlass",
  },
  {
    id: LeadServices?.serviceSeaCocks,
    value: "Service Sea-Cocks",
  },
  {
    id: LeadServices?.serviceBatteryMaintenance,
    value: "Battery Maintenance",
  },
  {
    id: LeadServices?.changeZincs,
    value: "Change Zincs",
  },
  {
    id: LeadServices?.moistureCheck,
    value: "Hull & Deck Moisture Check",
  },
];

export const StaticServicePaintworkArray = [
  {
    id: LeadServices?.exteriorPaintwork,
    value: "Exterior Paintwork",
  },

  {
    id: LeadServices?.interiorPaintwork,
    value: "Interior Paintwork",
  },
  {
    id: LeadServices?.varnishInterior,
    value: "Varnish Interior",
  },
  {
    id: LeadServices?.varnishExterior,
    value: "Varnish Exterior",
  },
  {
    id: LeadServices?.cabinSoles,
    value: "Cabin Soles",
  },
  {
    id: LeadServices?.awlgripTouchups,
    value: "Awlgrip Touchups",
  },
  {
    id: LeadServices?.gelcoatFiberglassRepairs,
    value: "Gelcoat / Fiberglass Repair",
  },
];

export const StaticServicePaintBottomArray = [
  {
    id: LeadServices?.paintBottom,
    value: "Paint Bottom",
  },
  {
    id: LeadServices?.compoundWaxTopsides,
    value: "Compound & Wax Topsides",
  },
  {
    id: LeadServices?.compoundWaxDeck,
    value: "Compound & Wax Deck",
  },
  {
    id: LeadServices?.polishStainless,
    value: "Polish Stainless",
  },
  {
    id: LeadServices?.thoroughInteriorClean,
    value: "Thorough Interior Cleaning",
    note: "Lockers, Bilges, Etc.",
  },
];

export const StorageSlugesLists = {
  winterStoreInsideUpto500sf: "6798743624f441645b352a96",
  winterStoreOutsideUpto500sf: "67987475b50d20dce72d9ef4",
  winterStoreInsideOver500sf: "67f648353ff4241731a212e9",
  winterStoreOutsideOver500sf: "67f6483dd8997c4fedcb3f5a",
  summerStoreInsideUpto500sf: "6846e25509f21ac97f06e7a3",
  summerStoreOutsideUpto500sf: "6846e25de1f36d0d0a2de911",
  summerStoreInsideOver500sf: "6846e2635a2a811766b9c15b",
  summerStoreOutsideOver500sf: "6846e269665f696a2b9c8b1d",
  OutboardWinterizeAndStore: "67989d61ec298e8a5863d054",
  mastStorage: "67c5a094e811e38e12441975",
  dinghyStore: "67989ceec4e2d2d2a6cc9bef",
  storageLockersSmall: "67c5adae56b94d18b6676b6a",
  storageLockersLarge: "67c5adbb41b6963f1082ccce",
};
export const storageSummerSlugsArray = [
  "6846e25509f21ac97f06e7a3",
  "6846e25de1f36d0d0a2de911",
  "6846e2635a2a811766b9c15b",
  "6846e269665f696a2b9c8b1d",
];
export const StorageSlugesListsArray = [
  "6798743624f441645b352a96",
  "67987475b50d20dce72d9ef4",
  "67f648353ff4241731a212e9",
  "67f6483dd8997c4fedcb3f5a",
  "6846e25509f21ac97f06e7a3",
  "6846e25de1f36d0d0a2de911",
  "6846e2635a2a811766b9c15b",
  "6846e269665f696a2b9c8b1d",
];
export const StorageButNonStorage = [
  "67989d61ec298e8a5863d054",
  "67c5a094e811e38e12441975",
  "67989ceec4e2d2d2a6cc9bef",
  "67c5adae56b94d18b6676b6a",
  "67c5adbb41b6963f1082ccce",
];
export const boatNameList = [
  { id: "Serendipity", name: "Serendipity" },
  { id: "Imagination", name: "Imagination" },
  { id: "Liberty", name: "Liberty" },
  { id: "Gale", name: "Gale" },
  { id: "Atlantis", name: "Atlantis" },
];

export const TimesheetApprovalStatus = {
  DRAFT: "draft",
  SUBMIT_APPROVAL: "pending_approval",
  APPROVED: "approved",
  PROCESSED: "processed",
};

export const TimeSheetFiltrStatus = [
  TimesheetApprovalStatus?.DRAFT,
  TimesheetApprovalStatus?.SUBMIT_APPROVAL,
  TimesheetApprovalStatus?.APPROVED,
  TimesheetApprovalStatus?.PROCESSED,
];

export const TimesheetStatusBadge: any = {
  draft: {
    color: "#8A8A8A",
    text: "Draft",
    svg: svg?.draftBadge,
  },
  approved: {
    color: "#062A54",
    text: "Approved",
    svg: svg?.approveBadge,
  },
  pending_approval: {
    color: "#CD9E13",
    text: "Pending Approval",
    svg: svg?.penddingTimesheetBadge,
  },
  processed: {
    color: "#00A21B",
    text: "Processed",
    svg: svg?.processedBadge,
  },
};

export const LeadStatusBadge: any = {
  1: {
    color: "#039B00",
    text: "New",
    svg: svg?.processedBadge,
  },
  2: {
    color: "#949494",
    text: "Pending",
    svg: svg?.penddingLeadBadge,
  },
  3: {
    color: "#062A54",
    text: "Accepted",
    svg: svg?.acceptedBadge,
  },
  4: {
    color: "#FF0000",
    text: "Rejected",
    svg: svg?.rejectBadge,
  },
  5: {
    color: "#CD9E13",
    text: "Estimated",
    svg: svg?.estimatedBagde,
  },
};

export const EstimateStatusBadge: any = {
  1: {
    color: "#8A8A8A",
    text: "In Progress",
    svg: svg?.draftBadge,
  },
  2: {
    color: "#CD9E13",
    text: "Pending Approval",
    svg: svg?.penddingBadge,
  },
  3: {
    color: "#00A21B",
    text: "Approved",
    svg: svg?.processedBadge,
  },
  4: {
    color: "#062A54",
    text: "Deposit Pending",
    svg: svg?.disposiPendingBadge,
  },
  6: {
    color: "#00A21B",
    text: "Manager Override Approval",
    svg: svg?.invoicePaid,
  },
  7: {
    color: "#00BBFF",
    text: "Processing Payment",
    svg: svg?.invoicePaymentProgress,
  },
};

export const EmployeeCurrentLocation: any = {
  yard: "#125084",
  harbor: "#CD9E13",
  offWork: "#FF0000",
  other: "#000000",
};

export const BoatArrayForSignIn = [
  {
    name: "Black Pearl",
    _id: "67ab0cb239f424ddb9610a5f",
  },
  {
    name: "Dutchman",
    _id: "67a9a2eaa7535055e6bd2eae",
  },
  {
    name: "Silent Mary",
    _id: "67a9f189a7535055e6bd72fb",
  },
];

export const WorkOrderForSignOut = [
  {
    name: "(Engine Repair)",
    _id: "67a214dec831606dbb73f7d2",
    order: "12356",
  },
  {
    name: "(Boat Cleaning)",
    _id: "67a9a2eaa7535055e6bd2eae",
    order: "1256887",
  },
  {
    name: "(Boat Inspection)",
    _id: "67a9f189a7535055e6bd72fb",
    order: "12388757",
  },
];

export const BillebleList = [
  {
    value: 0,
    label: "Not Billable",
  },
  {
    value: 1,
    label: "Billable",
  },
];

export const YearWeekList = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
  33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53,
];

export const ContactTypeList = [
  { name: "Lead", value: 0 },
  { name: "Customer", value: 1 },
  { name: "Vendor", value: 2 },
];

export const AssociatedType = {
  0: {
    name: "Boat",
    status: {
      0: {
        color: "#FF0000",
        text: "Inactive",
        svg: svg?.badgeRoundFailed,
      },
      1: {
        color: "#062A54",
        text: "Active",
        svg: svg?.approveBadge,
      },
    },
  },
  1: {
    name: "Change Order",
    status: {
      1: {
        color: "#8A8A8A",
        text: "In Progress",
        svg: svg?.draftBadge,
      },
      2: {
        color: "#CD9E13",
        text: "Pending Approval",
        svg: svg?.penddingBadge,
      },
      3: {
        color: "#00A21B",
        text: "Approved",
        svg: svg?.processedBadge,
      },
      4: {
        color: "#00A21B",
        text: "Manager Override Approval",
        svg: svg?.invoicePaid,
      },
    },
  },
  2: {
    name: "Estimate",
    status: {
      1: {
        color: "#8A8A8A",
        text: "In Progress",
        svg: svg?.draftBadge,
      },
      2: {
        color: "#CD9E13",
        text: "Pending Approval",
        svg: svg?.penddingBadge,
      },
      3: {
        color: "#00A21B",
        text: "Approved",
        svg: svg?.processedBadge,
      },
      4: {
        color: "#062A54",
        text: "Deposit Pending",
        svg: svg?.disposiPendingBadge,
      },
      6: {
        color: "#00A21B",
        text: "Manager Override Approval",
        svg: svg?.invoicePaid,
      },
    },
  },
  3: {
    name: "Issue",
    status: {
      open: {
        color: "#062A54",
        text: "Open",
        svg: svg?.approveBadge,
      },
      "in-progress": {
        color: "#CD9E13",
        text: "In Progress",
        svg: svg?.penddingBadge,
      },
      resolved: {
        color: "#00A21B",
        text: "Resolved",
        svg: svg?.badgeRoundSucess,
      },
    },
  },
  4: {
    name: "Storage Contract",
    status: {
      0: {
        color: "#CD9E13",
        text: "Pending Approval",
        svg: svg?.penddingBadge,
      },
      1: {
        color: "#062A54",
        text: "Deposit Pending",
        svg: svg?.disposiPendingBadge,
      },
      2: {
        color: "#00A21B",
        text: "Approved",
        svg: svg?.processedBadge,
      },
      3: {
        color: "#FF0000",
        text: "Expired",
        svg: svg?.roundDot,
      },
      4: {
        color: "#00A21B",
        text: "Manager Override Approval",
        svg: svg?.invoicePaid,
      },
    },
  },
  5: {
    name: "WO",
    status: {
      0: {
        color: "#8A8A8A",
        text: "Draft",
        svg: svg?.wo_pending,
      },
      1: {
        color: "#062A54",
        text: "Approved",
        svg: svg?.approveBadge,
      },
      2: {
        color: "#CC6D00",
        text: "In-Progress",
        svg: svg?.wo_in_progress,
      },
      3: {
        color: "#D9B500",
        text: "Ready to Start",
        svg: svg?.wo_ready_to_start,
      },
      4: {
        color: "#FF0000",
        text: "Delayed",
        svg: svg?.wo_delay,
      },
      6: {
        color: "#6B1A15",
        text: "Ready for Sign-Off",
        svg: svg?.wo_ready_sign_off,
      },
      5: {
        color: "#00A21B",
        text: "Complete",
        svg: svg?.wo_complate,
      },
      7: {
        color: "#0089D8",
        text: "Ready to Invoice",
        svg: svg?.wo_in_ready_to_invoice,
      },
      8: {
        color: "#970081",
        text: "Invoiced",
        svg: svg?.wo_invoiced,
      },
      9: {
        color: "#8A8A8A",
        text: "Pending CO",
        svg: svg?.wo_pending,
      },
    },
  },
  6: {
    name: "Invoice",
    status: {
      1: {
        color: "#8A8A8A",
        text: "Draft",
        svg: svg?.invoiceDraft,
      },
      2: {
        color: "#00A21B",
        text: "Paid",
        svg: svg?.invoicePaid,
      },
      3: {
        color: "#FF0004",
        text: "Overdue",
        svg: svg?.invoiceDue,
      },
      4: {
        color: "#062A54",
        text: "Sent",
        svg: svg?.invoiceSend,
      },
      5: {
        color: "#CC6D00",
        text: "Pending Approval",
        svg: svg?.invoicePending,
      },
      6: {
        color: "#C265DE",
        text: "Approved",
        svg: svg?.invoiceApproved,
      },
    },
  },
};

export const WorkOrderStatus: any = {
  0: {
    color: "#8A8A8A",
    text: "Draft",
    svg: svg?.wo_pending,
  },
  1: {
    color: "#062A54",
    text: "Approved",
    svg: svg?.approveBadge,
  },
  2: {
    color: "#CC6D00",
    text: "In-Progress",
    svg: svg?.wo_in_progress,
  },
  3: {
    color: "#D9B500",
    text: "Ready to Start",
    svg: svg?.wo_ready_to_start,
  },
  4: {
    color: "#FF0000",
    text: "Delayed",
    svg: svg?.wo_delay,
  },
  6: {
    color: "#6B1A15",
    text: "Ready for Sign-Off",
    svg: svg?.wo_ready_sign_off,
  },
  5: {
    color: "#00A21B",
    text: "Complete",
    svg: svg?.wo_complate,
  },
  7: {
    color: "#0089D8",
    text: "Ready to Invoice",
    svg: svg?.wo_in_ready_to_invoice,
  },
  8: {
    color: "#970081",
    text: "Invoiced",
    svg: svg?.wo_invoiced,
  },
  9: {
    color: "#8A8A8A",
    text: "Pending CO",
    svg: svg?.wo_pending,
  },
};

export const InvoicesStatus: any = {
  1: {
    color: "#8A8A8A",
    text: "Draft",
    svg: svg?.invoiceDraft,
  },
  2: {
    color: "#00A21B",
    text: "Paid",
    svg: svg?.invoicePaid,
  },
  3: {
    color: "#FF0004",
    text: "Overdue",
    svg: svg?.invoiceDue,
  },
  4: {
    color: "#062A54",
    text: "Sent",
    svg: svg?.invoiceSend,
  },
  5: {
    color: "#CC6D00",
    text: "Pending Approval",
    svg: svg?.invoicePending,
  },
  6: {
    color: "#C265DE",
    text: "Approved",
    svg: svg?.invoiceApproved,
  },
  10: {
    color: "#00BBFF",
    text: "Processing Payment",
    svg: svg?.invoicePaymentProgress,
  },
};
export const InvoicesReviewerListStatus: any = {
  3: {
    color: "#FF0004",
    text: "Declined",
    svg: svg?.invoiceDue,
  },
  4: {
    color: "#C265DE",
    text: "Approved",
    svg: svg?.invoiceApproved,
  },
  2: {
    color: "#CC6D00",
    text: "Pending Approval",
    svg: svg?.invoicePending,
  },
  1: {
    color: "#CC6D00",
    text: "Pending Approval",
    svg: svg?.invoicePending,
  },
};
// 0 : Ready to Start | 1 : Waiting for dependency | 2 : In-Progress | 3 : Complete
export const InvoicesStatusForFilter: any = [
  {
    _id: 1,
    label: "Draft",
  },
  {
    _id: 2,
    label: "Paid",
  },
  {
    _id: 3,
    label: "Overdue",
  },
  {
    _id: 4,
    label: "Sent",
  },
  {
    _id: 5,
    label: "Pending Approval",
  },
  {
    _id: 6,
    label: "Approved",
  },
];

export const inVoiceFilterForCustomer = [
  {
    _id: 2,
    label: "Paid",
  },
  {
    _id: 3,
    label: "Overdue",
  },
  {
    _id: 4,
    label: "Unpaid",
  },
];
export const CustomerInvoicesStatusForFilter: any = [
  {
    _id: 2,
    label: "Paid",
  },
  {
    _id: 3,
    label: "Overdue",
  },
  {
    _id: 7,
    label: "Unpaid",
  },
];
export const TaskStatus: any = {
  0: {
    color: "#D9B500",
    text: "Ready to Start",
    svg: svg?.wo_ready_to_start,
  },
  1: {
    color: "#0089D8",
    text: "Waiting for dependency",
    svg: svg?.wo_in_ready_to_invoice,
  },
  2: {
    color: "#CC6D00",
    text: "In-Progress",
    svg: svg?.wo_in_progress,
  },
  3: {
    color: "#00A21B",
    text: "Complete",
    svg: svg?.wo_complate,
  },
};

export const WorkOrderColumnNameArray = [
  "Boat Name",
  "WO #",
  "Work Area",
  "Type",
  "Department",
  "Details",
  "Planned Start Date",
];
export const WorkOrderColumnNameArray2 = [
  "Planned End Date",
  "Dependency",
  "Approved Hrs",
  "Actual Hrs",
  "Hrs Remaining",
  "% Completed",
  "Status",
];

export const statusColorMap = {
  green: "#e8fce8",
  yellow: "#fff9c4",
  red: "#ffd6d6",
};

export const ScheduleTaskContacts: any = [
  {
    id: 20,
    text: "New Task",
    backgroundColor: "#D9919A", // red background
    borderColor: "#D9919A", // red border
    textColor: "#fff", // white text
    start: "2025-06-02T07:30:00.000Z",
    end: "2025-06-02T10:30:00.000Z",
    duration: 5,
    progress: 2,
    type: "task",
    lazy: false,
  },
  {
    id: 47,
    text: "[1] Master project",
    backgroundColor: "#D9919A", // red background
    borderColor: "#D9919A", // red border
    textColor: "#fff", // white text
    start: "2025-06-02T10:30:00.000Z",
    end: "2025-06-02T12:30:00.000Z",
    duration: 8,
    progress: 0,
    parent: 0,
    type: "task",
  },
  {
    id: 22,
    text: "Task",
    backgroundColor: "#D9919A", // red background
    borderColor: "#D9919A", // red border
    textColor: "#fff", // white text
    start: "2025-06-02T12:30:00.000Z",
    end: "2025-06-02T15:30:00.000Z",
    duration: 8,
    progress: 0,
    type: "task",
  },
  {
    id: 21,
    text: "Task 4",
    start: "2025-06-02T15:30:00.000Z",
    end: "2025-06-02T16:30:00.000Z",
    duration: 3,
    progress: 0,
    type: "task",
  },
];
